import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'
/**
 * 查询历史告警分页
 * @param params
 */
export function getHistoryAlarmPage(params) {
    return request({
        url: envInfo.bgApp.nanhaiPath + '/tenant/history/historyAlarm',
        method: 'get',
        params
    })
}

/**
 * 告警趋势
 * @param params
 */
export function getAlarmTrend(params){
    return request({
        url: envInfo.bgApp.nanhaiPath + '/tenant/history/alarmTrend',
        method: 'get',
        params
    })
}

/**
 * 导出告警列表
 * @param params
 */
export function exportAlarm(params){
    return request({
        url: envInfo.bgApp.nanhaiPath + '/tenant/history/exportAlarm',
        method: 'post',
        data: params
    })
}

/**
 * 各级别告警个数
 * @param params
 */
export function alarmLevelCount(params){
    return request({
        url: envInfo.bgApp.nanhaiPath + '/tenant/history/alarmLevelCount',
        method: 'get',
        params
    })
}

/**
 * 系统列表查询
 */
export function getCategoryList() {
    return request({
        url: envInfo.bgApp.basePath + '/tenant/category/list',
        method: 'get',
    })
}

/**
 * 告警确认
 * @param params
 */
export function confirmAlarm(params){
    return request({
        url: envInfo.bgApp.pumpPath + '/alarm/confirm',
        method: 'post',
        data:params
    })
}

/**
 * 隔离告警确认
 * @param params
 */
export function isolateConfirm(params){
    return request({
        url: envInfo.bgApp.pumpPath + '/alarm/isolateConfirm',
        method: 'post',
        data:params
    })
}

/**
 * 点位报警批量确认
 * @param params
 */
export function batchConfirmAlarm(params){
    return request({
        url: envInfo.bgApp.pumpPath + '/alarm/batchConfirm',
        method: 'post',
        data:params
    })
}
